/******************************** Import Package ************************************/
import * as React from "react";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker as MuiDatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import TextField from "@mui/material/TextField";

/******************************** Date Picker ************************************/
export default function DatePicker(props) {
  const { name, label, value, onChange, error = null, ...other } = props;

  // Keep same structure as your old handler
  const convertToDefEventPara = (name, value) => ({
    target: {
      name,
      value,
    },
  });

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <MuiDatePicker
        label={label}
        value={value || null}
        onChange={(date) => onChange(convertToDefEventPara(name, date))}
        minDate={new Date(1994, 1, 1)}   // y, m, d
        maxDate={new Date(2050, 1, 31)}
        {...other}
        renderInput={(params) => (
          <TextField
            {...params}
            name={name}
            fullWidth
            error={!!error}
            helperText={error}
          />
        )}
      />
    </LocalizationProvider>
  );
}
